import { createReducer } from '@utils/helpers';
import * as actionTypes from './types';

const initialState = {
  postTipPageFeatures: null,
  agentsProfiles: [],
  tours: [],
  error: null,
  isLoading: false
};

const updatePostTipFeaturesSuccess = (state, postTipPageFeatures) => ({
  ...state,
  postTipPageFeatures,
  error: null
});

const updateExternalLinkSuccess = (state, postTipPageFeatures) => ({
  ...state,
  postTipPageFeatures,
  error: null
});

const fetchAgentsProfiles = state => ({
  ...state,
  isLoading: true
});

const fetchAgentsProfilesSuccess = (state, agentsProfiles) => ({
  ...state,
  agentsProfiles,
  isLoading: false,
  error: null
});

const fetchToursInit = state => ({
  ...state,
  isLoading: true
});

const fetchToursSuccess = (state, tours) => {
  return {
    ...state,
    error: null,
    isLoading: false,
    tours
  };
};

const facedError = (state, error) => ({
  ...state,
  error
});

const updateCommissionSettingsSuccess = (state, paymentCommission) => {
  return {
    ...state,
    paymentCommission,
    error: null
  };
};

export default createReducer(
  {
    [actionTypes.UPDATE_POST_TIP_FEATURES_SUCCESS]: updatePostTipFeaturesSuccess,
    [actionTypes.UPDATE_EXTERNAL_LINK_SUCCESS]: updateExternalLinkSuccess,
    [actionTypes.UPDATE_COMMISSION_SETTINGS_SUCCESS]: updateCommissionSettingsSuccess,
    [actionTypes.FETCH_AGENTS_PROFILES]: fetchAgentsProfiles,
    [actionTypes.FETCH_AGENTS_PROFILES_SUCCESS]: fetchAgentsProfilesSuccess,
    [actionTypes.FETCH_TOURS]: fetchToursInit,
    [actionTypes.FETCH_TOURS_SUCCESS]: fetchToursSuccess,
    [actionTypes.ACTION_ERROR]: facedError
  },
  initialState
);
